import { z } from "zod";
import { SHIFT_TENDER_TYPES } from "../shifts/enums.js";
/**
 * Yerel kasa (POS) ortak sabitleri ve Türkçe etiketleri (Prompt 15; özellik bayrağı `LOCAL_POS`).
 * Değerler `packages/db/migrations/0017_pos.sql` CHECK kısıtlarıyla BİREBİR aynıdır.
 */
/** Satış / iade. İptal ayrı bir tür DEĞİL, `status = VOID`'dir. */
export const POS_SALE_KINDS = ["SALE", "RETURN"];
export const posSaleKindSchema = z.enum(POS_SALE_KINDS);
export const POS_SALE_KIND_LABELS = {
    SALE: "Satış",
    RETURN: "İade",
};
export const POS_SALE_STATUSES = ["COMPLETED", "VOID"];
export const posSaleStatusSchema = z.enum(POS_SALE_STATUSES);
export const POS_SALE_STATUS_LABELS = {
    COMPLETED: "Tamamlandı",
    VOID: "İptal edildi",
};
/**
 * Kasa tahsilat türleri = vardiya beyanındaki `ShiftTenderType` + `CASH`.
 * Kasa nakit de tahsil eder; vardiya beyanında nakit ayrı sayılır, bu yüzden orada enum'da yoktur.
 */
export const POS_TENDER_TYPES = ["CASH", ...SHIFT_TENDER_TYPES];
export const posTenderTypeSchema = z.enum(POS_TENDER_TYPES);
export const POS_TENDER_TYPE_LABELS = {
    CASH: "Nakit",
    CARD: "Kredi / banka kartı",
    ON_ACCOUNT: "Veresiye (cari hesap)",
    FLEET: "Filo anlaşması",
    VEHICLE_RECOGNITION: "Taşıt tanıma sistemi (TTS)",
    MOBILE_PAYMENT: "Mobil ödeme",
    COUPON: "Kupon / fiş",
    LOYALTY_POINTS: "Sadakat puanı",
};
/** Veresiye / filo: satırdan vardiya fişi (`shift_credit_sales`) doğar. */
export const POS_CREDIT_TENDER_TYPES = ["ON_ACCOUNT", "FLEET"];
export const POS_LINE_KINDS = ["FUEL", "ITEM", "WASH", "EV", "SERVICE"];
export const posLineKindSchema = z.enum(POS_LINE_KINDS);
export const POS_LINE_KIND_LABELS = {
    FUEL: "Akaryakıt",
    ITEM: "Market ürünü",
    WASH: "Araç yıkama",
    EV: "Elektrikli araç şarjı",
    SERVICE: "Hizmet",
};
export const POS_SALE_SOURCES = ["POS", "API"];
export const posSaleSourceSchema = z.enum(POS_SALE_SOURCES);
export const POS_SALE_SOURCE_LABELS = {
    POS: "Yerel kasa (ajan senkronu)",
    API: "API / içe aktarma",
};
/**
 * Satış kabul edilirken üretilen uyarılar. **Hiçbiri satışı REDDETMEZ** (kalıcı ret satış kaybıdır):
 * kayıt yazılır, uyarı `pos_sales.warnings` alanına ve senkron yanıtına girer.
 */
export const POS_SALE_WARNINGS = [
    "FUEL_TRANSACTION_NOT_FOUND",
    "UNKNOWN_PRODUCT",
    "UNKNOWN_VAT_RATE",
    "UNKNOWN_STAFF",
    "UNKNOWN_CAMPAIGN",
    "UNKNOWN_COUNTERPARTY",
    "UNKNOWN_POS_TERMINAL",
    "UNKNOWN_CASH_REGISTER",
    "UNKNOWN_FISCAL_DEVICE",
    "SHIFT_NOT_FOUND",
    "FISCAL_SKIPPED",
    "CREDIT_LIMIT_EXCEEDED",
    "AFTER_DAY_LOCK",
    "TOTALS_MISMATCH",
    "EARCHIVE_REQUEST_FAILED",
    "RETENDERED",
    "FUEL_LINE_NOT_RETURNABLE",
    "LINE_ALREADY_RETURNED",
    // ── Prompt 17 (ADR 0017) ──
    "UNKNOWN_TENDER",
    "UNKNOWN_CUSTOMER",
    "UNKNOWN_VEHICLE",
    "FLEET_RULE_VIOLATION",
    "FLEET_RULE_OVERRIDDEN",
    "POINTS_OVERDRAWN",
    "COUPON_INVALID",
    "COUPON_ALREADY_REDEEMED",
    "ENTITLEMENT_OVERUSED",
];
export const posSaleWarningSchema = z.enum(POS_SALE_WARNINGS);
export const POS_SALE_WARNING_LABELS = {
    FUEL_TRANSACTION_NOT_FOUND: "Akaryakıt satırının pompa işlemi bulunamadı",
    UNKNOWN_PRODUCT: "Satırdaki ürün katalogda yok",
    UNKNOWN_VAT_RATE: "Satırdaki KDV oran kodu tanımlı değil",
    UNKNOWN_STAFF: "Satışı yapan personel bulunamadı",
    UNKNOWN_CAMPAIGN: "İndirimin kampanyası bulunamadı",
    UNKNOWN_COUNTERPARTY: "Tahsilat satırındaki cari bulunamadı",
    UNKNOWN_POS_TERMINAL: "Kart tahsilatının POS terminali bulunamadı",
    UNKNOWN_CASH_REGISTER: "Satışın kasası bulunamadı",
    UNKNOWN_FISCAL_DEVICE: "Fişi kesen ÖKC bu istasyonda tanımlı değil",
    SHIFT_NOT_FOUND: "Satış anında açık bir vardiya yoktu",
    FISCAL_SKIPPED: "Satış ÖKC fişi olmadan kaydedildi",
    CREDIT_LIMIT_EXCEEDED: "Veresiye satışta kredi limiti aşıldı",
    AFTER_DAY_LOCK: "Satış kilitlenmiş iş gününe düştü",
    TOTALS_MISMATCH: "Satır toplamları ile ödeme toplamı uyuşmuyor",
    EARCHIVE_REQUEST_FAILED: "e-Arşiv fatura talebi oluşturulamadı",
    RETENDERED: "Satışın ödeme türü sonradan düzeltildi",
    FUEL_LINE_NOT_RETURNABLE: "Akaryakıt satırı iade edilemez (litre pompadan çıktı)",
    UNKNOWN_TENDER: "Tanınmayan ödeme türü (kupon olarak kaydedildi)",
    UNKNOWN_CUSTOMER: "Satıştaki müşteri kaydı bulunamadı",
    UNKNOWN_VEHICLE: "Satıştaki araç kaydı bulunamadı",
    FLEET_RULE_VIOLATION: "Filo kuralı ihlal edildi (sunucu yeniden değerlendirdi)",
    FLEET_RULE_OVERRIDDEN: "Filo kuralı müdür onayıyla geçildi",
    POINTS_OVERDRAWN: "Puan harcaması bakiyeyi aştı (çevrimdışı)",
    COUPON_INVALID: "Kupon bulunamadı ya da geçersiz",
    COUPON_ALREADY_REDEEMED: "Kupon daha önce kullanılmış",
    ENTITLEMENT_OVERUSED: "Abonelik hakkı aşıldı (çevrimdışı)",
    LINE_ALREADY_RETURNED: "Satır daha önce iade edilmişti; yeniden ters yazılmadı",
};
/** Kasiyer hesabının BEKLENEN tutarının kaynağı (ADR 0015). */
export const POS_EXPECTED_SOURCES = ["POS", "MANUAL"];
export const posExpectedSourceSchema = z.enum(POS_EXPECTED_SOURCES);
export const POS_EXPECTED_SOURCE_LABELS = {
    POS: "Kasa satışları (POS)",
    MANUAL: "Elle girilen satış özeti",
};
/** PIN uzunluğu: 4–8 rakam (ajan argon2id ile doğrular; düz PIN ağdan geçmez). */
export const POS_PIN_MIN_LENGTH = 4;
export const POS_PIN_MAX_LENGTH = 8;
//# sourceMappingURL=enums.js.map